import { useState } from 'react'
import { supabase } from '@/lib/supabase'

export interface CheckEmailResult {
  exists: boolean
  user: {
    id: string
    email: string
    name: string | null
  } | null
  alreadyInAccount: boolean
}

export function useCheckEmail() {
  const [checking, setChecking] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const checkEmail = async (email: string, accountId: string): Promise<CheckEmailResult | null> => {
    if (!supabase) {
      setError('Supabase não configurado')
      return null
    }

    try {
      setChecking(true)
      setError(null)

      console.log('🔍 Checking email:', email, 'for account:', accountId)

      const { data, error: invokeError } = await supabase.functions.invoke('check-user-email', {
        body: { email, account_id: accountId }
      })

      if (invokeError) {
        console.error('❌ Check email error:', invokeError)
        throw invokeError
      }

      if (!data.success) {
        console.error('❌ Check email failed:', data.error)
        throw new Error(data.error)
      }

      console.log('✅ Check email result:', data.result)
      return data.result

    } catch (err: any) {
      const errorMessage = err.message || 'Erro ao verificar email'
      setError(errorMessage)
      console.error('❌ useCheckEmail error:', err)
      return null
    } finally {
      setChecking(false)
    }
  }

  return { checkEmail, checking, error }
}
